import React from "react";
import "./empty.css";
import emptyIcon from "../../../assets/images/not-found.png";

const Empty = ({ title }) => {
  return (
    <div className="emptyContainer">
      <img className="emptyImage" src={emptyIcon} alt="empty" />
      <span className="emptyTitle">{title}</span>
    </div>
  );
};
export default Empty;
